export const NOTICE_TYPES = {
  ERROR: "error",
  NOTICE: "notice",
};
